<template>
    <div
        class="w-full py-12 flex justify-center three-image-cards"
        v-observe-visibility="visibilityChanged"
    >
        <div class="container text-center">
            <h2
                v-if="devise.title.text"
                class="mb-6 text-4xl font-sans-lato font-light"
            >
                {{ devise.title.text }}
            </h2>
            <div v-html="devise.description.text" class="mb-4 mx-8"></div>
            <div
                class="flex flex-col md:flex-row justify-center items-center md:items-stretch"
            >
                <div
                    v-if="devise.card1Image.url"
                    class="flex justify-center items-stretch m-8"
                    style="width: 323px"
                >
                    <div
                        class="bg-abs-white three-image-cards card flex flex-col justify-start w-full"
                    >
                        <div>
                            <img
                                v-devise-image="{
                                    image: devise.card1Image,
                                    breakpoint: breakpoint,
                                }"
                            />
                        </div>
                        <div class="flex-1 flex flex-col justify-between">
                            <div class="text-center p-4">
                                <div class="font-bold card-title">
                                    {{ devise.card1Title.text }}
                                </div>
                                <div
                                    class="card-body"
                                    v-html="devise.card1Description.text"
                                ></div>
                            </div>
                            <div
                                class="card-body p-4"
                                v-if="
                                    devise.card1Link && devise.card1Link.enabled
                                "
                            >
                                <a
                                    class="flex items-center text-bold"
                                    :href="devise.card1Link.url"
                                >
                                    {{ devise.card1Link.text }}
                                    <svg
                                        class="w-4 h-4 ml-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 5l7 7-7 7"
                                        ></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="devise.card2Image.url"
                    class="flex justify-center items-stretch m-8"
                    style="max-width: 323px"
                >
                    <div
                        class="bg-abs-white three-image-cards card flex flex-col justify-start"
                    >
                        <div>
                            <img
                                v-devise-image="{
                                    image: devise.card2Image,
                                    breakpoint: breakpoint,
                                }"
                            />
                        </div>
                        <div class="flex-1 flex flex-col justify-between">
                            <div class="text-center p-4">
                                <div class="font-bold card-title">
                                    {{ devise.card2Title.text }}
                                </div>
                                <div
                                    class="card-body"
                                    v-html="devise.card2Description.text"
                                ></div>
                            </div>
                            <div
                                class="card-body p-4"
                                v-if="
                                    devise.card2Link && devise.card2Link.enabled
                                "
                            >
                                <a
                                    class="flex items-center text-bold"
                                    :href="devise.card2Link.url"
                                >
                                    {{ devise.card2Link.text }}
                                    <svg
                                        class="w-4 h-4 ml-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 5l7 7-7 7"
                                        ></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="devise.card3Image.url"
                    class="flex justify-center items-stretch m-8"
                    style="max-width: 323px"
                >
                    <div
                        class="bg-abs-white three-image-cards card flex flex-col justify-start w-full"
                    >
                        <div>
                            <img
                                v-devise-image="{
                                    image: devise.card3Image,
                                    breakpoint: breakpoint,
                                }"
                            />
                        </div>
                        <div class="flex-1 flex flex-col justify-between">
                            <div class="text-center p-4">
                                <div class="font-bold card-title">
                                    {{ devise.card3Title.text }}
                                </div>
                                <div
                                    class="card-body"
                                    v-html="devise.card3Description.text"
                                ></div>
                            </div>
                            <div
                                class="card-body p-4"
                                v-if="
                                    devise.card3Link && devise.card3Link.enabled
                                "
                            >
                                <a
                                    class="flex items-center text-bold"
                                    :href="devise.card3Link.url"
                                >
                                    {{ devise.card3Link.text }}
                                    <svg
                                        class="w-4 h-4 ml-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 5l7 7-7 7"
                                        ></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
    name: 'ThreeImageCards',

    data() {
        return {
            isVisible: false,
        };
    },

    computed: {
        numberOfCards() {
            let numberOfCards = 0;

            if (this.devise.card1Image.url) {
                numberOfCards += 1;
            }
            if (this.devise.card2Image.url) {
                numberOfCards += 1;
            }
            if (this.devise.card3Image.url) {
                numberOfCards += 1;
            }

            return numberOfCards;
        },
    },

    mounted() {
        anime({
            targets: '.three-image-cards.card',
            translateY: 100,
            opacity: 0,
            duration: 0,
        });
    },

    methods: {
        visibilityChanged(isVisible) {
            this.isVisible = isVisible;

            if (this.isVisible) {
                anime({
                    targets: '.three-image-cards.card',
                    translateY: 0,
                    opacity: 1,
                    duration: 5000,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(200),
                });
            } else {
                anime({
                    targets: '.three-image-cards.card',
                    translateY: 100,
                    opacity: 0,
                    duration: 2000,
                });
            }
        },
    },
};
</script>
